/** Хост отдельного входа «физюра» (fizur.inforensic.dev / .pro). */
export const isFizurHost = (): boolean =>
  typeof window !== "undefined" && window.location.hostname.startsWith("fizur.");

/** Шаблон Excel своей среды: запросы в нём ходят в API той же среды. */
export const fizurTemplateUrl = (): string =>
  window.location.hostname.endsWith(".dev") ? "/fizur/fizur-template-dev.xlsx" : "/fizur/fizur-template.xlsx";

const FIZUR_KEY_STORAGE = "fizur_api_key";

/** Отдельный ключ поддомена: без входа в кабинет выгрузка доступна только по нему. */
export const getFizurApiKey = (): string => {
  try {
    return sessionStorage.getItem(FIZUR_KEY_STORAGE) ?? "";
  } catch {
    return "";
  }
};

export const setFizurApiKey = (key: string): void => {
  try {
    if (key) sessionStorage.setItem(FIZUR_KEY_STORAGE, key);
    else sessionStorage.removeItem(FIZUR_KEY_STORAGE);
  } catch {
    // Без хранилища ключ действует только до обновления страницы.
  }
};
